import { GlobalAccount, GUID } from '@ndvr/customer-api';
import { DataType } from '@ndvr/portfolio-api';

import { getHouseholdName } from 'utils';
import { useCommandCenterHouseholdProfile } from 'views/household/household-queries';
import { useCreateAccountGroup } from 'views/portfolio/portfolio-queries';

/** Creates a portfolio (account group) in a household; the backend adds a default draft account to it. */
export const useCreatePortfolio = (householdGUID: GUID<GlobalAccount>) => {
    const { mutate, isPending } = useCreateAccountGroup();
    const { data: householdProfile } = useCommandCenterHouseholdProfile(householdGUID);
    const householdName = householdProfile ? getHouseholdName(householdProfile.globalAccount) : '';
    const defaultPortfolioName = householdName ? `${householdName} Portfolio` : '';

    const createPortfolio = (
        portfolioName: string,
        { onSuccess }: { onSuccess?: (newAccountGroupGUID: string | undefined) => void } = {},
    ) =>
        mutate(
            {
                householdGUID,
                request: {
                    accountGroupName: {
                        encryptionContextGUID: householdGUID,
                        dataType: DataType.PORTFOLIO_NAME,
                        plainText: portfolioName.trim(),
                    },
                },
            },
            { onSuccess },
        );

    return { createPortfolio, defaultPortfolioName, isPending };
};
